import { Modal, Radio } from "antd";
import React from "react";
import { useWindowsSize } from "../../libs";
import ErrorPage from "../Notification/Error";

function Covid({ props }) {
  const {
    isVisibleCovid,
    onCancelCovid,
    covid,
    onCovid,
    loading,
    onSaveCovid,
    isError,
  } = props;

  const goal = [
    "Penerbangan Domestik",
    "Penerbangan Luar Negeri",
    "Perjalanan Darat",
    "Keperluan Pekerjaan",
    "Keperluan Pendidikan",
    "Keperluan Menjaga Pasien",
    "Screening",
    "Lain-lain",
  ];

  const size = useWindowsSize();

  return (
    <Modal
      title={null}
      visible={isVisibleCovid}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={size.width > 640 ? 750 : 450}
    >
      <div>
        <p className="colors-blue text-2xl mb-3 font-bold header-title-bold ">
          Formulir Layanan Covid
        </p>
        <p className="colors-gray text-base header-content ">
          Isi data formulir layanan covid untuk melanjutkan transaksi
        </p>

        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-1 gap-1 lg:gap-10 ">
            <div>
              <div name="tanggal-form" className="mt-5">
                <p className="login-title-form mb-1 text-lg">Vaksin Terakhir</p>
                <input
                  value={covid.last_vaksin}
                  onChange={(e) => onCovid(e)}
                  disabled={loading}
                  name="last_vaksin"
                  type="date"
                  className="form-input outline-none w-full p-3"
                  placeholder="silahkan pilih tanggal"
                />

                {isError
                  ? isError.length > 0
                    ? isError
                        .filter((it) => it.type === "last_vaksin")
                        .map((its, idx) => (
                          <ErrorPage
                            key={idx}
                            props={{ idx, message: its.message }}
                          />
                        ))
                    : null
                  : null}
              </div>

              <div name="vaksin-form" className="mt-5">
                <p className="login-title-form mb-1 text-lg">Total Vaksin</p>
                <select
                  value={covid.vaksin_attemp}
                  onChange={(e) => onCovid(e)}
                  disabled={loading}
                  name="vaksin_attemp"
                  className="form-input outline-none w-full p-3 pr-4"
                  placeholder="Vaksin ke ?"
                >
                  <option className="colors-gray" value={null}>
                    Belum vaksin
                  </option>
                  <option className="colors-gray" value={1}>
                    1 Kali
                  </option>
                  <option className="colors-gray" value={2}>
                    2 Kali
                  </option>
                  <option className="colors-gray" value={3}>
                    3 Kali
                  </option>
                </select>
              </div>

              <div name="vaksin-form" className="mt-5">
                <p className="login-title-form mb-1 text-lg">
                  Tujuan Pemeriksaan
                </p>
                <select
                  value={covid.tujuan_pemeriksaan}
                  onChange={(e) => onCovid(e)}
                  disabled={loading}
                  name="tujuan_pemeriksaan"
                  className="form-input outline-none w-full p-3 pr-4"
                  placeholder="Tujuan Pemeriksaan ?"
                >
                  <option className="colors-gray" value={0}>
                    Tujuan layanan pemeriksaan kamu?
                  </option>
                  {goal.map((item, index) => (
                    <option
                      className="colors-gray"
                      key={index}
                      value={Number(index) + 1}
                    >
                      {item}
                    </option>
                  ))}
                </select>

                {isError
                  ? isError.length > 0
                    ? isError
                        .filter((it) => it.type === "tujuan_pemeriksaan")
                        .map((its, idx) => (
                          <ErrorPage
                            key={idx}
                            props={{ idx, message: its.message }}
                          />
                        ))
                    : null
                  : null}

                {Number(covid.tujuan_pemeriksaan) === 8 && (
                  <div>
                    <input
                      value={covid.tujuan_lain}
                      onChange={(e) => onCovid(e)}
                      disabled={loading}
                      name="tujuan_lain"
                      className="form-input outline-none w-full p-3 lg:p-4 mt-3"
                      placeholder="Tulis tujuan lain lain"
                    />

                    {isError
                      ? isError.length > 0
                        ? isError
                            .filter((it) => it.type === "tujuan_lain")
                            .map((its, idx) => (
                              <ErrorPage
                                key={idx}
                                props={{ idx, message: its.message }}
                              />
                            ))
                        : null
                      : null}
                  </div>
                )}
              </div>

              {Number(covid.tujuan_pemeriksaan) === 2 && (
                <div name="tujuan-form" className="mt-5">
                  <p className="login-title-form mb-1 text-lg">
                    Negara Tujuan Perjalanan
                  </p>
                  <input
                    value={covid.negara_tujuan}
                    onChange={(e) => onCovid(e)}
                    disabled={loading}
                    name="negara_tujuan"
                    className="form-input outline-none w-full p-3 lg:p-4 "
                    placeholder="Tulis negara tujuan perjalanan"
                  />

                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "negara_tujuan")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
              )}

              {Number(covid.tujuan_pemeriksaan) === 2 && (
                <div name="passport-form" className="mt-5">
                  <p className="login-title-form mb-1 text-lg">No. Passport</p>
                  <input
                    value={covid.no_passport}
                    onChange={(e) => onCovid(e)}
                    disabled={loading}
                    name="no_passport"
                    className="form-input outline-none w-full p-3 lg:p-4 "
                    placeholder="Tulis nomor passport anda"
                  />

                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "no_passport")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
              )}
            </div>

            <div>
              <div name="notice-form" className="mt-5 lg:mt-3">
                <p className="login-title-form mb-4 lg:mb-2 text-lg lg:text-base">
                  Apakah dalam 7 hari terakhir melakukan perjalanan luar negeri?
                </p>
                <Radio.Group
                  onChange={(e) => onCovid(e)}
                  value={covid.is_vacation}
                  name="is_vacation"
                  disabled={loading}
                >
                  <Radio value={true}>Iya</Radio>
                  <Radio value={false}>Tidak</Radio>
                </Radio.Group>
              </div>

              {covid.is_vacation && (
                <div name="input-form" className="mt-5 lg:mt-7">
                  <p className="login-title-form mb-1 text-lg">
                    Tujuan Bepergian
                  </p>
                  <input
                    value={covid.tujuan_bepergian}
                    onChange={(e) => onCovid(e)}
                    disabled={loading}
                    name="tujuan_bepergian"
                    className="form-input outline-none w-full p-3 lg:p-4 "
                    placeholder="Tulis tujuan bepergian anda"
                  />

                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "tujuan_bepergian")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
              )}

              {covid.is_vacation && (
                <div name="tanggal-form" className="mt-5">
                  <p className="login-title-form mb-1 text-lg">
                    Tanggal Perjalanan
                  </p>
                  <input
                    value={covid.tgl_bepergian}
                    onChange={(e) => onCovid(e)}
                    disabled={loading}
                    name="tgl_bepergian"
                    type="date"
                    className="form-input outline-none w-full p-3"
                    placeholder="silahkan pilih tanggal"
                  />

                  {isError
                    ? isError.length > 0
                      ? isError
                          .filter((it) => it.type === "tgl_bepergian")
                          .map((its, idx) => (
                            <ErrorPage
                              key={idx}
                              props={{ idx, message: its.message }}
                            />
                          ))
                      : null
                    : null}
                </div>
              )}
            </div>
          </div>
        </div>

        <div>
          {/* {cashError.length > 0 && (
            <div className="mt-5">
              <ErrorPage key={1} props={{ idx: 1, message: cashError }} />
            </div>
          )} */}
          <button
            onClick={onSaveCovid}
            disabled={loading}
            className="btn-blue w-full p-3 mt-8 focus:outline-none"
          >
            <div className="text-white lg:text-lg">
              {loading ? "Loading" : "Checkout"}
            </div>
          </button>
          <p
            onClick={onCancelCovid}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Batal
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Covid;
